<template>
    <div>
        <p class="text-center w-fonts-text-medium">{{ title || "Log in" }}</p>
        <div v-if="idgoogle && idfacebook && !$root.overley_login">
            <FacebookBtn
                @loggedIn="onLoggedIn"
                @registry="existRegistryFacebook"
                @registryData="registryDataFacebook"
                app-id="366040276789345"
            ></FacebookBtn>

            <!--
            <GoogleBtn
                @loggedIn="onLoggedIn"
                @registry="existRegistryGoogle"
                @registryData="registryDataGoogle"
                :google-id="googleId"
            ></GoogleBtn>
            -->

            <GoogleBtnV2
                @loggedIn="onLoggedIn"
                @registry="existRegistryGoogle"
                @registryData="registryDataGoogle"
                :client-id="googleId"
            />

            <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-12 pb-0">
                    <div class="separator"><span>or</span></div>

                    <v-alert
                        v-if="msg"
                        dense
                        border="left"
                        type="error"
                    >
                        {{ msg }}
                    </v-alert>

                    <slot name="msg"></slot>
                    <!-- eslint-disable vue/no-unused-vars -->
                    <ValidationObserver
                        ref="observer"
                        v-slot="{ validate, reset }"
                    >
                    <!-- eslint-enable -->
                        <v-form
                            ref="form"
                            lazy-validation
                            class="login-form"
                            action="/login"
                            @submit.prevent="submitRegistry"
                            method="post"
                        >
                            <input type="hidden" name="next" :value="next" />
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="email"
                                rules="email_required"
                            >
                                <v-text-field
                                    v-model="email"
                                    :error-messages="errors"
                                    outlined
                                    name="email"
                                    placeholder="Email or username"
                                    autocomplete="on"
                                    append-icon="fal fa-envelope"
                                ></v-text-field>
                            </ValidationProvider>
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="password"
                                rules="password_required"
                            >
                                <v-text-field
                                    v-model="password"
                                    :error-messages="errors"
                                    :type="showPass ? 'text' : 'password'"
                                    id="password"
                                    outlined
                                    name="password"
                                    placeholder="Password"
                                    autocomplete="on"
                                    append-icon="fal fa-lock-alt"
                                ></v-text-field>
                            </ValidationProvider>
                            <div class="row w-block-remember">
                                <div class="col-6">
                                    <div class="form-group">
                                        <div class="checkbox">
                                            <label class="md-checkbox">
                                                <input
                                                    class="checkbox"
                                                    type="checkbox"
                                                    id="remember"
                                                    v-model="remember"
                                                    value="1"
                                                />
                                                <label for="remember"
                                                    >Remember me</label
                                                >
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="col-6 text-right"
                                >
                                    <a @click="showPass = !showPass">
                                        <span v-if="!showPass"
                                            >Show password</span
                                        >
                                        <span v-else>Hide password</span>
                                    </a>
                                </div>
                            </div>

                            <div class="captcha-wrap pt-4 pb-1" v-if="!skipCaptcha && backendAskedForCaptcha">
                                <VueRecaptcha
                                    :sitekey="sitekey"
                                    @verify="saveCaptcha"
                                    ref="recaptcha"
                                    :loadRecaptchaScript="true"
                                    @expired="onCaptchaExpired"
                                ></VueRecaptcha>
                                <v-messages
                                    :value="fieldErrors.recaptcha || []"
                                    color="error"
                                ></v-messages>
                            </div>

                            <v-btn
                                block
                                type="submit"
                                name="Login"
                                :loading="loading"
                                large
                                class="text-white"
                                color="#ff5a5f"
                            >
                                Log in
                            </v-btn>
                        </v-form>
                    </ValidationObserver>
                    <div class="text-center mt-5">
                        <span class="help-block"
                            ><a href="/forgot-password"
                                >Forgot your password?</a
                            ></span
                        >
                    </div>
                    <hr />
                    <div class="text-left">
                        Don't have an account?
                        <a href="/signup" @click.prevent="openSignupDialog">Sign up</a>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!idgoogle">
            <CompleteInformation
                @loggedIn="onLoggedIn"
                :profile="googleUser"
                url="/login/gsi"
            ></CompleteInformation>
        </div>

        <div v-if="!idfacebook">
            <CompleteInformation
                @loggedIn="onLoggedIn"
                :profile="facebookUser"
                url="/login/facebook"
            ></CompleteInformation>
        </div>
    </div>
</template>

<script>
import '~/css/shared/md-checkbox.css';
import '~/css/shared/login-signup-form.css';

import {
    extend,
    setInteractionMode,
    ValidationObserver,
    ValidationProvider,
} from "vee-validate";
import { required } from "vee-validate/dist/rules";
import VueRecaptcha from "vue-recaptcha";
import { mapGetters } from "vuex";

//import GoogleBtn from "@/components/auth/input/GoogleBtn.vue";
import CompleteInformation from "@/components/auth/CompleteInformation.vue";
import FacebookBtn from "@/components/auth/input/FacebookBtn.vue";
import GoogleBtnV2 from "@/components/auth/input/GoogleBtnV2.vue";
import authPopupHandler from "@/shared/auth-popup-handler";

//import csrfTokenResolver from '@/shared/csrf-token';

setInteractionMode("eager");

extend("email_required", {
    ...required,
    message: "Email or username cannot be empty",
});

extend("password_required", {
    ...required,
    message: "Password cannot be empty",
});

export default {
    props: {
        next: {
          type: [String, null],
          required: false,
          default: null,
        },
        title: {
            type: String,
            default: 'Log in',
        },
        googleId: String,
        sitekey: String,
        referal: {},
        skipCaptcha: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    name: "LoginForm",
    data: () => ({
        showPass: false,
        email: null,
        password: null,
        remember: false,
        rules: {
            required: (value) => !!value || "Required.",
            email: (v) =>
                /^[a-zA-Z0-9.!#$%&’*+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
                    v
                ) || "E-mail must be valid",
        },
        googleUser: null,
        idgoogle: true,
        facebookUser: null,
        idfacebook: true,
        loading: false,
        msg: null,
        backendAskedForCaptcha: false, // we allow users to make the first login attempt without a captcha
        recaptchaToken: null,
        recaptchaVerified: false,
        fieldErrors: {
            email: [],
            password: [],
            recaptcha: [],
        },
    }),
    computed: {
        ...mapGetters({
            staySamePage: "auth/getStaySamePage",
        }),
    },
    created() {
        // initFacebook();
        this.$nextTick(() => {
            this.$root.overley_login = false;
            if (document.getElementById("password")) {
                this.password = document.getElementById("password").value;
            }
        });
    },
    methods: {
        onLoggedIn() {
            if (this.staySamePage) {
                this.$store.commit(
                    "auth/setAuthenticated",
                    true
                );
                this.closeLoginDialog();
                return;
            }

            window.location.href = this.next || '/user/dashboard';
        },

        submitRegistry() {
            this.msg = null;

            if (!this.password && document.getElementById("password").value) {
                this.password = document.getElementById("password").value;
            }

            if (!this.recaptchaVerified && !this.skipCaptcha && this.backendAskedForCaptcha) {
                this.fieldErrors.recaptcha = ["Please solve the CAPTCHA"];
                return false;
            }

            if (this.$refs.form.validate() && this.email.length > 0) {
                this.loading = true;
                let params = new URLSearchParams();
                //

                params.append("email", this.email);
                params.append("password", this.password);
                params.append("remember", this.remember);
                params.append("recaptcha", this.recaptchaToken);

                this.$http.postCsrf("/login", params).then((response) => {
                    if (response.data.status) {
                        this.onLoggedIn();
                    } else {
                        this.msg = response.data.msg;
                        this.loading = false;
                    }
                })
                    .catch((error) => {
                        if (error?.response?.status === 419) {
                            this.msg = 'Your session expired. The page will be reloaded now.';

                            window.setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        } else if (error?.response?.status === 422) {
                            this.fieldErrors = error.response.data?.errors ?? [];

                            if (this.fieldErrors?.recaptcha) {
                                this.backendAskedForCaptcha = true;
                            }
                        }

                        this.loading = false;
                    })
                    .finally(() => {

                    });
            }
        },
        existRegistryGoogle(val) {
            this.idgoogle = val;
        },
        registryDataGoogle(val) {
            console.debug('Google user data:', val);

            this.googleUser = val;
        },
        existRegistryFacebook(val) {
            this.idfacebook = val;
        },
        registryDataFacebook(val) {
            this.facebookUser = val;
        },
        onCaptchaExpired() {
            this.$refs.recaptcha.reset();
        },
        saveCaptcha(recaptchaToken) {
            this.fieldErrors.recaptcha = [];
            this.recaptchaVerified = true;
            this.recaptchaToken = recaptchaToken;
        },
        closeLoginDialog() {
            this.$emit('close-dialog');
        },
        openSignupDialog() {
            this.closeLoginDialog();
            authPopupHandler.showSignupPopup();
        },
    },
    components: {
        CompleteInformation,
        FacebookBtn,
        // GoogleBtn,
        GoogleBtnV2,
        ValidationProvider,
        ValidationObserver,
        VueRecaptcha,
    },
};
</script>
